import axios from 'axios'
import AuiToast from '../../assets/js/aui-toast'

/**
 * 获取活跃连接列表
 */
const connectionList = async () => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function () { })
  return axios.get(`/api/jvcom/share-charge/v2/device/connections`)
    .then(res => {
      AuiToast.hide()
      return res
    })
}

/**
 * 远程启动充电
 */
const remoteStart = async (connectionId, stationCode) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function () { })
  return axios.post(`/api/jvcom/share-charge/v2/device/remote-start`, {
    connectionId,
    transactionId: '0',
    stationCode,
    gunId: 1,
    logicCardNo: '0',
    physicalCardNo: '0',
    balance: 9999
  })
    .then(res => {
      AuiToast.hide()
      return res
    })
}

/**
 * 远程停止充电
 */
const remoteStop = async (connectionId, stationCode) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function () { })
  return axios.post(`/api/jvcom/share-charge/v2/device/remote-stop`, {
    connectionId,
    stationCode,
    gunId: 1,
  })
    .then(res => {
      AuiToast.hide()
      return res
    })
}

/**
 * 工作参数设置
 * maxPowerPercent 取值范围：30-100
 */
const workSettings = async (connectionId, stationCode, maxPowerPercent) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function () { })
  return axios.post(`/api/jvcom/share-charge/v2/device/work-settings`, {
    connectionId,
    stationCode,
    allowWork: true,
    maxPowerPercent
  })
    .then(res => {
      AuiToast.hide()
      return res
    })
}

/**
 * 最后一次实时数据​
 * @param stationCode {String} 桩编码
 */
const realTimeDataLatest = async (stationCode) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function () { })
  return axios.get(`/api/jvcom/share-charge/v2/device/real-time-data/latest?stationCode=${stationCode}`)
    .then(res => {
      AuiToast.hide()
      return res
    })
}


const chargePile = {
  connectionList,
  remoteStart,
  remoteStop,
  workSettings,
  realTimeDataLatest
}
export default chargePile
